class MediaQueryService {
  constructor($rootScope, $window) {
    'ngInject';
    this.$rootScope = $rootScope;
    this.$window = $window;

    // Media query definitions
    this.breakpoints = {
      mobile: '(max-width: 768px)',
      tablet: '(min-width: 769px) and (max-width: 1024px)',
      desktop: '(min-width: 1025px)',
      portrait: '(orientation: portrait)',
      landscape: '(orientation: landscape)'
    };

    // Initial checks
    this.mediaMatches = {};
    Object.keys(this.breakpoints).forEach(key => {
      this.mediaMatches[key] = $window.matchMedia(this.breakpoints[key]).matches;
    });

    // Listen to changes on each media query
    Object.keys(this.breakpoints).forEach(key => {
      $window.matchMedia(this.breakpoints[key]).addListener((e) => {
        this.mediaMatches[key] = e.matches;
        this.$rootScope.$broadcast('mediaChange', { type: key, matches: e.matches });
      });
    });
  }

  matches(queryName) {
    return this.mediaMatches[queryName];
  }

  isMobileDevice() {
    return this.matches('mobile');
  }

  isTabletDevice() {
    return this.matches('tablet');
  }

  isDesktopDevice() {
    return this.matches('desktop');
  }

  isPortrait() {
    return this.matches('portrait');
  }

  isLandscape() {
    return this.matches('landscape');
  }
}
export default MediaQueryService;
